import { handleActions } from 'redux-actions';
import { combineReducers } from 'redux';

import { search, searchIdle, searchSuccess, searchFailure, loadMore, loadMoreSuccess } from '../actions';

const data = handleActions(
  {
    [searchSuccess]: (state, { payload }) => (payload),
    [searchFailure]: (state, { payload }) => (payload),
    [loadMoreSuccess]: (state, { payload }) => {
      return {
        ...state,
        posts: [
          ...state.posts,
          ...payload.posts
        ]
      };
    },
    [search]: (state, { payload }) => ({}),
    [searchIdle]: () => ({})
  },
  {}
);

const status = handleActions(
  {
    [search]: () => 'LOADING',
    [searchSuccess]: () => 'SUCCESS',
    [searchFailure]: () => 'FAILURE',
    [searchIdle]: () => 'IDLE'
  },
  'IDLE'
);

export default combineReducers({
  data,
  status
});